import { gql } from "lib/apolloClient";
import { courseFragment } from "Course/modules/CourseFragments";
export const staffCourseFragment = {
  staffCourse: gql`
    fragment staffItem on Staff {
      id
      courses(orderBy: TITLE, orderByDirection: ASC, filters: $filters) {
        ...courseItem
      }
    }
    ${courseFragment.courseUnitPlanFeedCount}
  `,
  StaffCourseStudents: gql`
    fragment staffItem on Staff {
      id
      courses(orderBy: TITLE, orderByDirection: ASC, filters: $filters) {
        ...courseItem
      }
    }
    ${courseFragment.StaffCourseStudents}
  `,
  staffCourseGenericFoldersBasicDetails: gql`
    fragment staffItem on Staff {
      id
      coursesV2(filters: $filters) {
        edges {
          node {
            ...courseItem
          }
        }
      }
    }
    ${courseFragment.courseGenericFoldersBasicDetailsFragment}
  `,
};

export const studentCourseFragment = {
  studentCourse: gql`
    fragment studentCourseItem on Student {
      id
      courses(orderBy: TITLE, orderByDirection: ASC, filters: $filters) {
        ...courseFeedItem
      }
    }
    ${courseFragment.courseFeed}
  `,
  studentCourseTags: gql`
    fragment studentCourseTags on Student {
      courseMap(filters: $courseIdsFilter) {
        id
        course {
          id
        }
        tags {
          id
          label
        }
      }
    }
  `,
};

export const staffCourseV2Fragment = {
  staffCourseBasicDetails: gql`
    fragment staffItem on Staff {
      id
      coursesV2(
        first: $first
        after: $after
        filters: $filters
        orderBy: TITLE
        orderByDirection: ASC
      ) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...courseItem
          }
        }
      }
    }
    ${courseFragment.courseBasicDetails}
  `,
};

export const singleCourseV2Fragment = {
  singleCourseV2: gql`
    fragment courseV2 on Course {
      id
      title
      isBookmark
      profileImageData {
        url
        icon
      }
      gradesWithAcademicYear {
        grade {
          id
          name
        }
        academicYear {
          id
          startDate
          endDate
        }
      }
      grade {
        id
        name
      }
      subjects {
        id
        name
      }
      grades(filters: $courseGradeFilters) {
        id
        name
      }
      genericTags(filters: { types: SUBJECT_LEVEL }) {
        id
        label
        type
      }
      primaryGrade(filters: $courseGradeFilters) {
        id
        name
      }
      subjectGroups {
        id
        name
        type
      }
      academicYears {
        id
      }
    }
  `,
};
